import { useEffect } from 'react';
import type { i18n } from 'i18next';
import { resolveLanguage, LOCALE_KEY } from './i18n.config';

/** Sincroniza o idioma do i18next com mudanças em localStorage['locale']. */
export function useLanguageSync(i18n: i18n): void {
  useEffect(() => {
    async function handleStorageChange(event: StorageEvent): Promise<void> {
      if (event.key !== LOCALE_KEY) return;

      const resolved = resolveLanguage(event.newValue);
      if (resolved !== i18n.language) {
        await i18n.changeLanguage(resolved);
      }
    }

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n]);
}
